import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=0a43e8d8"
import script from "./NavigationTabs.vue?vue&type=script&lang=js"
export * from "./NavigationTabs.vue?vue&type=script&lang=js"
import style0 from "./NavigationTabs.vue?vue&type=style&index=0&id=0a43e8d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports